import { CommunityRequest } from "utils/fetch-community-requests";

export const mockCommunityRequests: CommunityRequest[] = [
  {
    solicitation_id: "4005d94f-e1f9-4849-9368-f79b4992a2ae",
    solicitation_title:
      "My First Solicitation Apex ID: 4005d94f-e1f9-4849-9368-f79b4992a2ae",
    created_at: "2025-06-22T20:21:59.516Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Zebra Police Department",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gkeAmMKSd8"
  },
  {
    solicitation_id: "3d6dea6e-8b36-4e14-9092-a20f85352b51",
    solicitation_title:
      "My First Solicitation Apex ID: 3d6dea6e-8b36-4e14-9092-a20f85352b51",
    created_at: "2025-06-22T20:42:08.044Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Alpha Fire Department",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/8LdeMwLCk8"
  },
  {
    solicitation_id: "990617ea-8367-4398-b5dd-d66fa8b207a6",
    solicitation_title:
      "My First Solicitation Apex ID: 990617ea-8367-4398-b5dd-d66fa8b207a6",
    created_at: "2025-06-23T01:24:36.120Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Metro Police Department",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/bG205PNcwg"
  },
  {
    solicitation_id: "5ac1e23d-5a9f-4a87-b97f-1615a7bee5b6",
    solicitation_title:
      "My First Solicitation Apex ID: 5ac1e23d-5a9f-4a87-b97f-1615a7bee5b6",
    created_at: "2025-06-23T21:12:03.484Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Boston Sheriff's Office",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/jBzEvowHzj"
  },
  {
    solicitation_id: "68a4bc87-06b5-484e-ace3-c12a69a2c3c5",
    solicitation_title:
      "My First Solicitation Apex ID: 68a4bc87-06b5-484e-ace3-c12a69a2c3c5",
    created_at: "2025-06-27T06:53:46.658Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/beeB5RXTWb"
  },
  {
    solicitation_id: "952b6cce-4857-4b93-9ea0-a32a6780af65",
    solicitation_title:
      "My First Solicitation Apex ID: 952b6cce-4857-4b93-9ea0-a32a6780af65",
    created_at: "2025-07-08T00:04:58.006Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gpGak7QFdj"
  },
  {
    solicitation_id: "07fe0571-4ccc-4a29-a8cd-6296c493a0d0",
    solicitation_title:
      "My First Solicitation Apex ID: 07fe0571-4ccc-4a29-a8cd-6296c493a0d0",
    created_at: "2025-07-08T01:42:15.039Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gWr26L2tej"
  },
  {
    solicitation_id: "a18c8878-f4b3-411c-922c-8136d13d2b06",
    solicitation_title:
      "My First Solicitation Apex ID: a18c8878-f4b3-411c-922c-8136d13d2b06",
    created_at: "2025-07-08T08:58:28.964Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/bzda6wyHYj"
  },
  {
    solicitation_id: "4c9b598f-1eb6-437c-86e3-9874a991ffe8",
    solicitation_title:
      "My First Solicitation Apex ID: 4c9b598f-1eb6-437c-86e3-9874a991ffe8",
    created_at: "2025-07-08T10:16:20.279Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gYl4VqMhGj"
  },
  {
    solicitation_id: "31cf0704-3abb-430f-ab8d-40a8de5f957b",
    solicitation_title:
      "My First Solicitation Apex ID: 31cf0704-3abb-430f-ab8d-40a8de5f957b",
    created_at: "2025-07-08T20:45:42.605Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/g60rVvlTz8"
  },
  {
    solicitation_id: "e6f60136-f030-4032-93a1-ecd125b5dc75",
    solicitation_title:
      "My First Solicitation Apex ID: e6f60136-f030-4032-93a1-ecd125b5dc75",
    created_at: "2025-07-08T23:14:26.126Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/brd3kaxhAj"
  },
  {
    solicitation_id: "903cfc0b-af4a-4975-9271-ebb1e62934b4",
    solicitation_title:
      "My First Solicitation Apex ID: 903cfc0b-af4a-4975-9271-ebb1e62934b4",
    created_at: "2025-07-08T23:45:42.068Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/jBzERRPIzj"
  },
  {
    solicitation_id: "3b42543e-144e-4e93-987d-17a31cf90b3a",
    solicitation_title:
      "My First Solicitation Apex ID: 3b42543e-144e-4e93-987d-17a31cf90b3a",
    created_at: "2025-07-08T23:57:38.527Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/bdkG772Szg"
  },
  {
    solicitation_id: "7aa47d57-d684-424c-a138-a193b85eb1f3",
    solicitation_title:
      "My First Solicitation Apex ID: 7aa47d57-d684-424c-a138-a193b85eb1f3",
    created_at: "2025-07-09T00:31:18.228Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/j3M2L0esnb"
  },
  {
    solicitation_id: "fcabcaf2-2d35-4f7c-a655-69261bd15855",
    solicitation_title:
      "My First Solicitation Apex ID: fcabcaf2-2d35-4f7c-a655-69261bd15855",
    created_at: "2025-07-09T01:19:48.240Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/bmPmxW9iMg"
  },
  {
    solicitation_id: "eaa9f921-1d00-4ffd-aa35-d0498799736e",
    solicitation_title:
      "My First Solicitation Apex ID: eaa9f921-1d00-4ffd-aa35-d0498799736e",
    created_at: "2025-07-09T01:31:57.497Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gMY2vlGCag"
  },
  {
    solicitation_id: "97080b0c-9d73-49c7-9505-077eed08e216",
    solicitation_title:
      "My First Solicitation Apex ID: 97080b0c-9d73-49c7-9505-077eed08e216",
    created_at: "2025-07-09T17:53:48.830Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gXLGa90Czg"
  },
  {
    solicitation_id: "23b58a15-8138-4bef-9b95-4b9c881cf66d",
    solicitation_title:
      "My First Solicitation Apex ID: 23b58a15-8138-4bef-9b95-4b9c881cf66d",
    created_at: "2025-07-09T19:18:10.487Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/802xvR7i1g"
  },
  {
    solicitation_id: "164915ff-7e6f-483b-91ac-b7043a7477e9",
    solicitation_title:
      "My First Solicitation Apex ID: 164915ff-7e6f-483b-91ac-b7043a7477e9",
    created_at: "2025-07-09T19:33:20.538Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/j7nLYZ7T38"
  },
  {
    solicitation_id: "9997a7c0-0dab-49a7-beef-dbf4d7401474",
    solicitation_title:
      "My First Solicitation Apex ID: 9997a7c0-0dab-49a7-beef-dbf4d7401474",
    created_at: "2025-07-09T20:27:23.952Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/8EPQprds5b"
  },
  {
    solicitation_id: "2c428943-b6d5-4f29-993b-56077ec0de89",
    solicitation_title:
      "My First Solicitation Apex ID: 2c428943-b6d5-4f29-993b-56077ec0de89",
    created_at: "2025-07-09T22:04:01.252Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/bLdeqMBhkb"
  },
  {
    solicitation_id: "af1d96b3-c4a7-4a12-8b86-931fd4f0685b",
    solicitation_title:
      "My First Solicitation Apex ID: af1d96b3-c4a7-4a12-8b86-931fd4f0685b",
    created_at: "2025-07-09T22:59:53.826Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/j02xvLrh1b"
  },
  {
    solicitation_id: "0ebf706a-934b-4a6c-8a52-c5c5bab6b8d7",
    solicitation_title:
      "My First Solicitation Apex ID: 0ebf706a-934b-4a6c-8a52-c5c5bab6b8d7",
    created_at: "2025-07-10T18:27:14.990Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/geeB1a0UWg"
  },
  {
    solicitation_id: "1a25d3bb-0ea8-4fcb-856a-dedbabdb876f",
    solicitation_title:
      "My First Solicitation Apex ID: 1a25d3bb-0ea8-4fcb-856a-dedbabdb876f",
    created_at: "2025-07-10T23:27:21.250Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gWr2BQZfej"
  },
  {
    solicitation_id: "e01b2321-b036-452f-b1f7-f80649a39b9a",
    solicitation_title:
      "My First Solicitation Apex ID: e01b2321-b036-452f-b1f7-f80649a39b9a",
    created_at: "2025-07-11T18:44:08.373Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gMY2dyGCag"
  },
  {
    solicitation_id: "1a7e1b0c-285c-4723-a36a-3b41eb851204",
    solicitation_title:
      "My First Solicitation Apex ID: 1a7e1b0c-285c-4723-a36a-3b41eb851204",
    created_at: "2025-07-11T19:29:34.576Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/jOr2Bq3ca8"
  },
  {
    solicitation_id: "cc6bba90-08c3-4917-982b-77f8efa20618",
    solicitation_title:
      "My First Solicitation Apex ID: cc6bba90-08c3-4917-982b-77f8efa20618",
    created_at: "2025-07-11T20:19:11.537Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/g2qnzQWT9j"
  },
  {
    solicitation_id: "689f409d-1573-4872-8540-250029a69017",
    solicitation_title:
      "My First Solicitation Apex ID: 689f409d-1573-4872-8540-250029a69017",
    created_at: "2025-07-11T20:27:20.274Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/jBzE7apIzj"
  },
  {
    solicitation_id: "213046c8-e102-4ac2-84d7-35a503ed852c",
    solicitation_title:
      "My First Solicitation Apex ID: 213046c8-e102-4ac2-84d7-35a503ed852c",
    created_at: "2025-07-11T20:48:09.530Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/bn4RKDkIdj"
  },
  {
    solicitation_id: "dfe8a6be-e9d2-424f-a53b-aa2a6e6071e3",
    solicitation_title:
      "My First Solicitation Apex ID: dfe8a6be-e9d2-424f-a53b-aa2a6e6071e3",
    created_at: "2025-07-14T22:30:33.176Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gXLGpYLizg"
  },
  {
    solicitation_id: "ac01d182-5e08-4f03-a6d1-db0d601668b6",
    solicitation_title:
      "My First Solicitation Apex ID: ac01d182-5e08-4f03-a6d1-db0d601668b6",
    created_at: "2025-07-22T17:53:59.859Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/bDLkGOOFPb"
  },
  {
    solicitation_id: "487b2697-b321-4d6e-9b19-5be46342d4dd",
    solicitation_title:
      "Solicitation Apex ID: 487b2697-b321-4d6e-9b19-5be46342d4dd",
    created_at: "2025-07-23T19:00:53.514Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gPLRLe1S5g"
  },
  {
    solicitation_id: "4d16b065-e993-4709-add9-f80e2e5ca955",
    solicitation_title:
      "My First Solicitation Apex ID: 4d16b065-e993-4709-add9-f80e2e5ca955",
    created_at: "2025-07-24T18:31:13.911Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/81mymWdcX8"
  },
  {
    solicitation_id: "88456b77-b336-4648-bfb0-b8a853092530",
    solicitation_title:
      "My First Solicitation Apex ID: 88456b77-b336-4648-bfb0-b8a853092530",
    created_at: "2025-07-24T18:38:05.160Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/8VzNz9eu48"
  },
  {
    solicitation_id: "6795b6af-9e95-446b-ba27-0cadddb71e9d",
    solicitation_title:
      "My First Solicitation Apex ID: 6795b6af-9e95-446b-ba27-0cadddb71e9d",
    created_at: "2025-07-24T19:00:12.811Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/8lN0NnYU4g"
  },
  {
    solicitation_id: "37bc317f-fd7e-4503-b3d2-c8cf40f4a4b7",
    solicitation_title:
      "My First Solicitation Apex ID: 37bc317f-fd7e-4503-b3d2-c8cf40f4a4b7",
    created_at: "2025-07-24T19:14:39.407Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/85nBnZvs5j"
  },
  {
    solicitation_id: "b275652c-eecd-41fb-b8fb-6474105d68a5",
    solicitation_title:
      "My First Solicitation Apex ID: b275652c-eecd-41fb-b8fb-6474105d68a5",
    created_at: "2025-07-24T19:57:10.217Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/j02D29Yh1b"
  },
  {
    solicitation_id: "c6721140-d2ad-4b87-b8e7-7ec759a1365f",
    solicitation_title:
      "My First Solicitation Apex ID: c6721140-d2ad-4b87-b8e7-7ec759a1365f",
    created_at: "2025-07-25T21:25:08.323Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/j60B9dXszb"
  },
  {
    solicitation_id: "a4bce158-d353-4f0a-9b68-23799990c46e",
    solicitation_title:
      "My First Solicitation Apex ID: a4bce158-d353-4f0a-9b68-23799990c46e",
    created_at: "2025-07-25T21:25:22.892Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/bwvWnAliBg"
  },
  {
    solicitation_id: "be0c0ec2-7372-4c8f-b93f-43ab2e285dec",
    solicitation_title:
      "My First Solicitation Apex ID: be0c0ec2-7372-4c8f-b93f-43ab2e285dec",
    created_at: "2025-08-04T23:12:02.707Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gWrmm9vtej"
  },
  {
    solicitation_id: "bf69d426-b353-41b3-947a-a83473195483",
    solicitation_title:
      "My First Solicitation Apex ID: bf69d426-b353-41b3-947a-a83473195483",
    created_at: "2025-08-04T23:12:56.406Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/j2qPPovt98"
  },
  {
    solicitation_id: "5a56dfa9-199a-4a69-9771-c9d647fc46e9",
    solicitation_title:
      "My First Solicitation Apex ID: 5a56dfa9-199a-4a69-9771-c9d647fc46e9",
    created_at: "2025-08-04T23:47:32.221Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/bwvWWMriBg"
  },
  {
    solicitation_id: "f0f72c60-5b4a-4bf5-9c1b-a72e68d85ebf",
    solicitation_title:
      "My First Solicitation Apex ID: f0f72c60-5b4a-4bf5-9c1b-a72e68d85ebf",
    created_at: "2025-08-04T23:57:58.523Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gXLKKY7Tzg"
  },
  {
    solicitation_id: "cac4a8cb-7abc-4cf2-a186-ec7bf1d349f9",
    solicitation_title:
      "My First Solicitation Apex ID: cac4a8cb-7abc-4cf2-a186-ec7bf1d349f9",
    created_at: "2025-08-11T19:54:28.394Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gdkDOl7hzj"
  },
  {
    solicitation_id: "59c75a7c-fd40-4919-9954-eec0b53826fe",
    solicitation_title:
      "My First Solicitation Apex ID: 59c75a7c-fd40-4919-9954-eec0b53826fe",
    created_at: "2025-08-14T22:55:10.789Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/j5nBq55u5g"
  },
  {
    solicitation_id: "5ee0301d-5c62-41e6-9f0a-4d1d8547cac5",
    solicitation_title:
      "My First Solicitation Apex ID: 5ee0301d-5c62-41e6-9f0a-4d1d8547cac5",
    created_at: "2025-08-15T16:10:33.661Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/brd0mvqhAj"
  },
  {
    solicitation_id: "885adca5-dabf-4626-a1ec-6af19c1959c6",
    solicitation_title:
      "My First Solicitation Apex ID: 885adca5-dabf-4626-a1ec-6af19c1959c6",
    created_at: "2025-08-15T18:34:13.074Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gzdWMK7CY8"
  },
  {
    solicitation_id: "725b9c34-f513-405a-a869-d1e2f205ba54",
    solicitation_title:
      "My First Solicitation Apex ID: 725b9c34-f513-405a-a869-d1e2f205ba54",
    created_at: "2025-08-15T23:51:12.640Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gMYawPPuag"
  },
  {
    solicitation_id: "a37ff958-6a85-44f9-9d79-66ca6b254c5c",
    solicitation_title:
      "My First Solicitation Apex ID: a37ff958-6a85-44f9-9d79-66ca6b254c5c",
    created_at: "2025-08-18T08:02:19.696Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gdkDYZ7Hzj"
  },
  {
    solicitation_id: "7fdef051-6bcf-4c3e-8bef-0e8094076a26",
    solicitation_title:
      "My First Solicitation Apex ID: 7fdef051-6bcf-4c3e-8bef-0e8094076a26",
    created_at: "2025-08-18T17:32:59.643Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gpG0OMzudj"
  },
  {
    solicitation_id: "b452e34f-541a-404e-ae0f-0f5e9f3e4eb2",
    solicitation_title:
      "Apex ID Solicitation: b452e34f-541a-404e-ae0f-0f5e9f3e4eb2: Mon Aug 18 2025 10:52:32 GMT-0700 (Pacific Daylight Time) to Mon Aug 18 2025 04:52:32 GMT-0700 (Pacific Daylight Time)",
    created_at: "2025-08-18T17:52:40.455Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gqX3Qk6swj"
  },
  {
    solicitation_id: "9c58d22b-039f-47e9-b831-adbaa442ea80",
    solicitation_title:
      "My First Solicitation Apex ID: 9c58d22b-039f-47e9-b831-adbaa442ea80",
    created_at: "2025-08-19T21:48:49.145Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/8EPk27zH5b"
  },
  {
    solicitation_id: "dab02d6c-7f71-495e-901c-b877828ce0fd",
    solicitation_title:
      "My First Solicitation Apex ID: dab02d6c-7f71-495e-901c-b877828ce0fd",
    created_at: "2025-08-26T20:27:31.737Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/g3MXvZYhn8"
  },
  {
    solicitation_id: "c899611e-d00a-4bed-8947-8b2b2e406282",
    solicitation_title:
      "My First Solicitation Apex ID: c899611e-d00a-4bed-8947-8b2b2e406282",
    created_at: "2025-08-27T01:00:51.713Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/8Bz5vvQCz8"
  },
  {
    solicitation_id: "eb419e66-7644-4bf6-a1f5-6f53b2b02955",
    solicitation_title:
      "My First Solicitation Apex ID: eb419e66-7644-4bf6-a1f5-6f53b2b02955",
    created_at: "2025-09-03T18:20:18.349Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/bZBkXpPF5b"
  },
  {
    solicitation_id: "b3c2a658-5fb9-4e7a-97fd-ed2a1bfa25d5",
    solicitation_title:
      "My First Solicitation Apex ID: b3c2a658-5fb9-4e7a-97fd-ed2a1bfa25d5",
    created_at: "2025-06-23T17:44:49.249Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/jDL4vGehPj"
  },
  {
    solicitation_id: "b2b436ed-7215-439d-b774-f530a57df21a",
    solicitation_title:
      "My First Solicitation Apex ID: b2b436ed-7215-439d-b774-f530a57df21a",
    created_at: "2025-07-09T23:27:21.851Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/85nz3Y2f5j"
  },
  {
    solicitation_id: "cfa97b2a-1153-43e7-97e7-2fd8d2e444e0",
    solicitation_title:
      "My First Solicitation Apex ID: cfa97b2a-1153-43e7-97e7-2fd8d2e444e0",
    created_at: "2025-07-10T18:39:11.012Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gXLGkAPczg"
  },
  {
    solicitation_id: "25711b0b-fe31-4fda-9218-ba5febb9c793",
    solicitation_title:
      "My First Solicitation Apex ID: 25711b0b-fe31-4fda-9218-ba5febb9c793",
    created_at: "2025-07-10T23:06:50.222Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/bZBWaQRh5b"
  },
  {
    solicitation_id: "2df81b2d-3935-492c-acc9-c1ce28823cf0",
    solicitation_title:
      "My First Solicitation Apex ID: 2df81b2d-3935-492c-acc9-c1ce28823cf0",
    created_at: "2025-07-11T21:23:52.428Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gYl4r4DhGj"
  },
  {
    solicitation_id: "42a5728b-97ce-4bdb-ab76-9977dc9933ad",
    solicitation_title:
      "My First Solicitation Apex ID: 42a5728b-97ce-4bdb-ab76-9977dc9933ad",
    created_at: "2025-07-11T22:23:34.542Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gYl4rzLIGj"
  },
  {
    solicitation_id: "af93ae98-edf2-4290-bda5-ff17f8f22994",
    solicitation_title:
      "My First Solicitation Apex ID: af93ae98-edf2-4290-bda5-ff17f8f22994",
    created_at: "2025-07-14T20:42:24.793Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gywa174t48"
  },
  {
    solicitation_id: "f91df101-b149-4735-90fe-f6fce2247285",
    solicitation_title:
      "My First Solicitation Apex ID: f91df101-b149-4735-90fe-f6fce2247285",
    created_at: "2025-07-14T21:10:11.880Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/bQe212EHOb"
  },
  {
    solicitation_id: "d5e0edae-2485-4fd5-a887-ca47a9cd9d65",
    solicitation_title:
      "My First Solicitation Apex ID: d5e0edae-2485-4fd5-a887-ca47a9cd9d65",
    created_at: "2025-07-17T08:05:38.877Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/8wvaGP4FBb"
  },
  {
    solicitation_id: "bd2ed156-7d8b-423a-bdc6-b9872606d350",
    solicitation_title:
      "My First Solicitation Apex ID: bd2ed156-7d8b-423a-bdc6-b9872606d350",
    created_at: "2025-07-31T04:35:09.384Z",
    city: "",
    state: "",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/8wvWQVzfBb"
  },
  {
    solicitation_id: "e1986dd7-279f-4431-b252-da66bae9b9e5",
    solicitation_title:
      "My First Solicitation Apex ID: e1986dd7-279f-4431-b252-da66bae9b9e5",
    created_at: "2025-08-11T20:00:21.877Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/brd0OEAhAj"
  },
  {
    solicitation_id: "b7beb80c-ee14-4ea4-bc1c-1c207953a6bf",
    solicitation_title:
      "My First Solicitation Apex ID: b7beb80c-ee14-4ea4-bc1c-1c207953a6bf",
    created_at: "2025-08-11T20:09:12.595Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/8LdkmeXCk8"
  },
  {
    solicitation_id: "3dc8876c-bede-4a9a-86f2-619ffdf7da1b",
    solicitation_title:
      "My First Solicitation Apex ID: 3dc8876c-bede-4a9a-86f2-619ffdf7da1b",
    created_at: "2025-08-18T22:18:48.801Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/jBz5OaRszj"
  },
  {
    solicitation_id: "82e10092-f044-45c0-9712-bcc8096a780c",
    solicitation_title:
      "My First Solicitation Apex ID: 82e10092-f044-45c0-9712-bcc8096a780c",
    created_at: "2025-08-20T23:28:12.135Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/8DLkRALcP8"
  },
  {
    solicitation_id: "25c2edae-69f3-40e4-b286-f3bdbac29f3c",
    solicitation_title:
      "My First Solicitation Apex ID: 25c2edae-69f3-40e4-b286-f3bdbac29f3c",
    created_at: "2025-08-21T22:03:46.161Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/802DyQOi1g"
  },
  {
    solicitation_id: "d3a38e31-5418-494b-9334-24c669e579c0",
    solicitation_title:
      "My First Solicitation Apex ID: d3a38e31-5418-494b-9334-24c669e579c0",
    created_at: "2025-08-22T23:05:07.512Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/8Bz5wQZSz8"
  },
  {
    solicitation_id: "a53175e3-04a6-4f49-b8cb-ae7fdd994f31",
    solicitation_title:
      "My First Solicitation Apex ID: a53175e3-04a6-4f49-b8cb-ae7fdd994f31",
    created_at: "2025-08-22T23:10:40.053Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gakwQX6uV8"
  },
  {
    solicitation_id: "d941df64-216e-4717-ad30-6ab2075adbfe",
    solicitation_title:
      "My First Solicitation Apex ID: d941df64-216e-4717-ad30-6ab2075adbfe",
    created_at: "2025-08-22T23:22:52.132Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/85nBkdmt5j"
  },
  {
    solicitation_id: "a35c1f30-bc43-4cc0-887d-957314a681db",
    solicitation_title:
      "My First Solicitation Apex ID: a35c1f30-bc43-4cc0-887d-957314a681db",
    created_at: "2025-08-22T23:40:17.535Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/gn40QamUd8"
  },
  {
    solicitation_id: "e8e08238-7002-498a-a587-021516eec7a4",
    solicitation_title:
      "My First Solicitation Apex ID: e8e08238-7002-498a-a587-021516eec7a4",
    created_at: "2025-08-26T20:07:41.465Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/bKWk02NC3b"
  },
  {
    solicitation_id: "98d6c821-ba98-417c-867b-996105503cb5",
    solicitation_title:
      "My First Solicitation Apex ID: 98d6c821-ba98-417c-867b-996105503cb5",
    created_at: "2025-08-26T20:48:23.619Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/bXLK0P3hzb"
  },
  {
    solicitation_id: "cfd4ee1e-83d5-4b15-ac01-9a7a9b2f000c",
    solicitation_title:
      "My First Solicitation Apex ID: cfd4ee1e-83d5-4b15-ac01-9a7a9b2f000c",
    created_at: "2025-08-29T00:32:39.763Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/bPLRAlWh5b"
  },
  {
    solicitation_id: "14a6abc7-6a44-4225-afb8-dfe8f4d2b082",
    solicitation_title:
      "My First Solicitation Apex ID: 14a6abc7-6a44-4225-afb8-dfe8f4d2b082",
    created_at: "2026-01-16T22:31:42.911Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/bwvMGm1CBg"
  },
  {
    solicitation_id: "564f0cfd-bdb1-41b1-b57c-ed5b857bb153",
    solicitation_title:
      "My First Solicitation Apex ID: 564f0cfd-bdb1-41b1-b57c-ed5b857bb153",
    created_at: "2026-01-16T22:55:34.900Z",
    city: "Los Angeles",
    state: "CA",
    evidence_platform: "Axon Community Requests",
    agency_name: "Demo Law Enforcement Agency",
    agency_uuid: "c838d202-27dd-4320-8125-434a50b32b0f",
    video_submissions: 0,
    post_url: "https://neighbors.dev.ring.com/n/jwvMG0vCB8"
  }
];
